import { Role } from '@models/Role';
import { User } from '@models/User';
import dirnameRe from 'dirname-regex';

import { meta, url, type AppUrl } from '../../.split-pages/meta';

export interface PageMeta {
  title?: string;
  titleCn?: string;
  icon?: string;
  order?: number;
  listed?: boolean;
  staffOnly?: boolean;
  superuserOnly?: boolean;
  rolesOnly?: Role[];
  breadcrumbs?: { to?: string; children: string }[];
}

export interface Meta extends PageMeta {
  url: string;
  name: string;
  isDirectory: boolean;
}

export const getBreadcrumb = (pathname: string) => {
  const path: Meta[] = [];
  let current = pathname;

  while (current.length > 0) {
    const m = MetaHelper.shared.meta.find((m) => m.url === current);

    if (m) {
      path.unshift(m);
    }

    current = current.match(dirnameRe())![2]!;
  }

  return path;
};

export class MetaHelper {
  static instance: MetaHelper | undefined;

  static get shared() {
    if (MetaHelper.instance === undefined) {
      MetaHelper.instance = new MetaHelper();
    }
    return MetaHelper.instance;
  }

  get meta() {
    return meta as Meta[];
  }

  getPageMeta(pathname: string): Meta | undefined {
    return this.meta.find((m) => m.url === pathname);
  }

  withPrefix(prefix: string, metas: Meta[] = this.meta) {
    return this.sorted(metas.filter((m) => m.url.startsWith(prefix)));
  }

  sorted(metas: Meta[] = this.meta) {
    return [...metas].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  shouldVisit(meta: Meta, user: User) {
    if (meta.rolesOnly) {
      if (!meta.rolesOnly.find((item) => item === user.role)) {
        return false;
      }
    }
    if (meta.superuserOnly) {
      return user.is_superuser;
    }
    if (meta.staffOnly) {
      return user.is_staff || user.is_superuser;
    }
    return true;
  }
}

export { url, type AppUrl };
